import { RemoteUpdatePartner } from 'data/usecases/partners';
import { makeApiUrlPartners } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteUpdatePartner = (): RemoteUpdatePartner => {
  return new RemoteUpdatePartner(makeApiUrlPartners(), makeAxiosHttpClient());
};
